import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { departmentFormSchema } from './department-form-schema';
import { defaultValues } from './model';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(departmentFormSchema),
    defaultValues,
  });
}
